import React from 'react';
import logo from '../../assets/images/logo.png'

const Seaprint = ({ seaprint, shipperData }) => {
    return (
        <div className="page-content" ref={seaprint}>
            <div className='seaprint'>
                <table className='w-100 main-table'>
                    <tbody>
                        <tr valign="top">
                            <td className='w-50 left-side' style={{ padding: "0" }}>
                                <table className='w-100'>
                                    <tr>
                                        <td valign='top' style={{ padding: "0" }} className="w-50">
                                            <table className='w-100'>
                                                <td style={{ padding: "0" }} valign="top">
                                                    <table className='w-100 notify'>
                                                        <thead>
                                                            <tr>
                                                                <th>SHIPPER</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr style={{ height: "80px" }}>
                                                                <td className='text-color'>{shipperData?.shipper}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr valign="top">
                                        <td valign='top' style={{ padding: "0" }} className="w-50">
                                            <table className='w-100'>
                                                <tr>
                                                    <td style={{ padding: "0" }} valign="top">
                                                        <table className='w-100 notify'>
                                                            <thead>
                                                                <tr>
                                                                    <th>CONSGINEE</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr style={{ height: "80px" }}>
                                                                    <td className='text-color'>{shipperData?.consignee}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ padding: "0" }} valign="top">
                                                        <table className='w-100 notify'>
                                                            <thead>
                                                                <tr>
                                                                    <th>NOTIFY</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr style={{ height: "80px" }}>
                                                                    <td className='text-color'>{shipperData?.notify}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr className='placedelivery-part br-0'>
                                                    <td style={{ padding: "0" }} valign="top" className='bl-line'>
                                                        <table className='w-100 port-item border-right-0'>
                                                            <thead>
                                                                <tr>
                                                                    <th> <p className="s1">PLACE OF RECEIPT</p></th>
                                                                    <th> <p className="s1"> PORT OF LOADING</p></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td className='text-color'>{shipperData?.placeOfReceipt}</td>
                                                                    <td className='text-color'>{shipperData?.portOfLoading}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>

                                </table>
                            </td>
                            {/* RightCOl Start */}
                            <td className='w-50 right-side br-line' style={{ padding: "0" }}>
                                <table className='w-100'>
                                    <tr>
                                        <td style={{ padding: "0" }} className="agent-details w-50">
                                            <table className='w-100 notify'>
                                                <thead>
                                                    <tr>
                                                        <th className='text-center py-3' style={{ color: "#000" }}>GLOTTIS PVT LTD
                                                            <br />
                                                            <img src={logo} alt="logo-glottis" width={`150px`} />
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr><td>BILL OF LADING NUMBER: <span className='text-color'>{shipperData?.billOfLoadingNumber}</span></td></tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr valign='top'>
                                        <td style={{ padding: "0" }} className="agent-details w-50">
                                            <table className='w-100 notify'>
                                                <thead>
                                                    <tr>
                                                        <th>DESTINATION AGENT DETAILS :</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className='text-color'> <span className='text-color'>{shipperData?.destinationAgentDetails}</span></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                            {/* RightCOl Start End */}
                        </tr>
                        {/* row-2 star */}
                        <tr valign="top">
                            <td className='w-50 left-side' style={{ padding: "0" }}>
                                <table className='w-100'>
                                    <tr className='placedelivery-part'>
                                        <td style={{ padding: "0" }} valign="top" className='w-50 bl-line'>
                                            <table className='w-100 port-item'>
                                                <thead>
                                                    <tr>
                                                        <th> <p className="s1">VESSEL & VOY</p></th>
                                                        <th> <p className="s1"> PORT OF DISCHARGE</p></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className='text-color'>{shipperData?.vesselAndVoy}</td>
                                                        <td className='text-color'>{shipperData?.portOfDischarge}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                            <td className='w-50 right-side br-line' style={{ padding: "0" }}>
                                <table className='w-100'>
                                    <tr className='placedelivery-part'>

                                        <td style={{ padding: "0" }} valign="top" className='w-50'>
                                            <table className='w-100 endplace'>
                                                <thead>
                                                    <tr>
                                                        <th className='text-center'> <p className="s1 text-center">PLACE OF DELIVERY</p></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className='text-center text-color'>{shipperData?.portOfDelivery}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                        {/* row-2 end */}
                    </tbody>
                </table>
                <table className='w-100 placedelivery-part br-line'>
                    <thead>
                        <tr>
                            <th className='border-box w-25'> <p className="text-center">CONTAINER NUMBER / TYPE</p></th>
                            <th className='border-box'> <p className="text-center">No.Of.Pkgs</p></th>
                            <th className='border-box w-25'> <p className="text-center">Description of the Goods</p></th>
                            <th className='border-box'> <p className="text-center">GROSS WEIGHT</p></th>
                            <th className='border-box'> <p className="text-center">NET WEIGHT</p></th>
                            <th className='border-box'> <p className="text-center">CBM</p></th>
                        </tr>
                    </thead>
                    <tbody>
                        {shipperData?.packageDetails?.map((item, index) => (
                            <tr key={index}>
                                <td className='text-color bl-line text-center'>{item?.containerNumberOrType}</td>
                                <td className='text-color bl-line text-center'>{item?.noOfPkgs}</td>
                                <td className='text-color bl-line text-center'>{item?.descriptionOfTheGoods}</td>
                                <td className='text-color bl-line text-center'>{item?.grossWeight}</td>
                                <td className='text-color bl-line text-center'>{item?.netWeight}</td>
                                <td className='text-color bl-line text-center'>{item?.CBM}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <table className='w-100 placedelivery-part bb-line '>
                    <thead>
                        <tr>
                            <th className='border-box br-0'> <p className="s1">MARKS & NUMBERS</p></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className='text-color bl-line br-line'>{shipperData?.marksAndNumbers}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Seaprint;